import { connect } from 'react-redux'

import hmPaySelectors from 'features/account/hm-pay/duck/selectors'

import { toggleInbox } from '../../duck/actions'
import inboxSelectors from '../../duck/selectors'
import Inbox from './Inbox.component'

const mapStateToProps = (state): any => {
  const shouldShowInbox = inboxSelectors.getShouldShowInbox(state)
  const isOpen = inboxSelectors.getIsOpen(state)
  const hasUnreadMessages = !inboxSelectors.getAreAllMessagesRead(state)
  const isKlarnaAuthenticated = hmPaySelectors.getIsKlarnaAuthenticated(state)

  return {
    shouldShowInbox,
    isOpen,
    hasUnreadMessages,
    isKlarnaAuthenticated,
  }
}

const mapDispatchToProps = {
  toggleInbox,
}

export default connect(mapStateToProps, mapDispatchToProps)(Inbox)
